import React from 'react';
import ErrorBoundary from '../../../components/ErrorBoundary';
import PresencesManagement from './index';

const CassaIntegrazioneManagementList = React.lazy(() =>
  import('./CassaIntegrazioneManagementList')
);

const CassaIntegrazioneManagementPage = (props) => {
  return (
    <PresencesManagement scrolling>
      <ErrorBoundary>
        <React.Suspense fallback={<div />}>
          <CassaIntegrazioneManagementList {...props} />
        </React.Suspense>
      </ErrorBoundary>
    </PresencesManagement>
  );
};

export default CassaIntegrazioneManagementPage;
